/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'system': {
    width: 20,
    height: 21,
    viewBox: '0 0 20 21',
    data: '<defs><path pid="0" id="svgicon_system_a" d="M0 0h20v20H0z"/></defs><g transform="translate(0 .25)" _fill="none" fill-rule="evenodd"><mask id="svgicon_system_b" _fill="#fff"><use xlink:href="#svgicon_system_a"/></mask><path pid="1" d="M13.626 2.164c.52 0 1.01.29 1.26.75l3.56 6.46c.24.44.24.97 0 1.42l-3.56 6.45c-.25.47-.74.75-1.26.75h-7.07c-.53 0-1.01-.28-1.27-.75l-3.56-6.45a1.49 1.49 0 010-1.42l3.56-6.46c.26-.46.74-.75 1.27-.75zm-.01 1.25h-7.06a.21.21 0 00-.18.11l-3.55 6.46c-.04.06-.04.14 0 .2l3.55 6.46c.04.06.11.1.18.1h7.06c.08 0 .15-.04.18-.1l3.56-6.46c.03-.06.03-.14 0-.2l-3.56-6.46a.189.189 0 00-.18-.11zm-3.585 3.253c1.84 0 3.34 1.49 3.34 3.33s-1.5 3.34-3.34 3.34c-1.84 0-3.33-1.5-3.33-3.34 0-1.84 1.49-3.33 3.33-3.33zm0 1.25c-1.15 0-2.08.93-2.08 2.08s.93 2.09 2.08 2.09 2.09-.94 2.09-2.09-.94-2.08-2.09-2.08z" _fill="#FFF" mask="url(#svgicon_system_b)"/></g>'
  }
})
